import { AutogenLayoutEDIAccuracyDetail } from "./autogen/AutogenLayoutEDIAccuracyDetail";

export class EDIAccuracyDetail extends AutogenLayoutEDIAccuracyDetail {}